module.exports = __webpack_public_path__ + "static/img/RDS_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RDS_1.png
// module id = 7eaR
// module chunks = 0